__turbopack_context__.v({
  "Select": "GyHDLa_Select",
  "SelectWrapper": "GyHDLa_SelectWrapper",
});
